import React from "react";
import { Link } from "react-router-dom";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css"; 
import "slick-carousel/slick/slick-theme.css";
import { Row, Spinner } from "react-bootstrap";
import "./index.scss";
import { useTranslation } from "react-i18next";

const ArticlesSlider = ({ articles, loading, error }) => {
  const { t } = useTranslation();

  const truncateContent = (content, maxLength) => {
    if (!content) return "";
    return content.length > maxLength ? content.substring(0, maxLength) + "..." : content;
  };

  const SliderSettings = {
    dots: true,
    infinite: false,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    centerMode: false,
    arrows: true,
    draggable: true,
    adaptiveHeight: false,
  };

  const handleMouseDown = (e) => {
    e.preventDefault(); 
  };

  if (loading) {
    return (
      <div
        style={{
          position: "absolute",
          left: "50%",
          top: "50%",
          transform: "translate(-50%, -50%)"
        }}
      >
        <Spinner
          as="div"
          animation="grow"
          size="sm"
          role="status"
          aria-hidden="true"
          className="align-middle my-auto"
        />
        <span>{t('articleSlider.loadingMessage')}</span>
      </div>
    );
  }

  if (error)
    return (
      <div className="text-center text-danger mx-auto">{t('articleSlider.errorMessage')}</div>
    );

  return (
    <Row style={{ marginLeft: 0, marginRight: 0, marginTop: 40, marginBottom: 40, justifyContent: "center" }}>
      <div onMouseDown={handleMouseDown} style={{ width: "100%", maxWidth: "800px", textAlign: "center" }}>
        <Slider {...SliderSettings}>
          {articles.data
            ?.slice(0, 3)
            .map((article) => (
              <div key={article.id} className="article-container">
                <Link to={`/news/single-view/${article.id}`} style={{ textDecoration: 'none', color: 'inherit' }}>
                  <div className="article" style={{ 
                    background: "#f9f9f9", 
                    borderRadius: "24px", 
                    boxShadow: "0 2px 5px rgba(0,0,0,0.2)",
                    padding: "20px", 
                    margin: "0 10px", 
                    textAlign: "center", 
                    minHeight: "300px",
                  }}>
                    <h2 style={{ fontSize: "1.5rem", marginBottom: "10px" }}>{article.title}</h2>
                    <div dangerouslySetInnerHTML={{ __html: truncateContent(article.body?.processed || article.body?.value, 300) }} />
                    <small style={{ display: "block", marginTop: "10px" }}>{t('articleSlider.created')}{new Date(article.created).toLocaleDateString()}</small>
                  </div>
                </Link>
              </div>
            ))}
        </Slider>
      </div>
    </Row>
  );
};

export default ArticlesSlider;
